// https://vuex.vuejs.org/en/mutations.html

export default {
  //
  includePart(state,payload){
    state.affectedParts.push(payload);
  },
  removePart(state, index){
    if(index > -1)
      state.affectedParts.splice(index, 1)
  }

}
